'use client'

import * as React from 'react'
import { CookiesProvider } from 'react-cookie'
import { PolyfillContext } from 'custom-polyfills/context'
import { PaymentsDialogProvider } from 'payments/components/payments-dialog-wrapper-context'
import { GrowthBookProvider } from 'growthbook'

import { ReactQueryProvider } from './query-client-provider'

export function Providers({ children }: React.PropsWithChildren) {
  return (
    <CookiesProvider>
      <PolyfillContext>
        <ReactQueryProvider>
          <GrowthBookProvider>
            <PaymentsDialogProvider>{children}</PaymentsDialogProvider>
          </GrowthBookProvider>
        </ReactQueryProvider>
      </PolyfillContext>
    </CookiesProvider>
  )
}
